/*
 network api
*/
import axios from "../axios/axios";

export function getNetworks(params) {
  return axios.post('/references/networks', params);
}
